
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    empresa: '',
    telefone: '',
    cargo: '',
    mensagem: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3js9edok22kmcvg48ig', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          empresa: '',
          telefone: '',
          cargo: '',
          mensagem: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Acelere suas Vendas
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Entre em contato e descubra como nossa IA pode transformar sua prospecção
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-6">Fale Conosco</h3>
            
            <form id="contato-take-lead" onSubmit={handleSubmit} className="space-y-6" data-readdy-form>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-gray-300 mb-2">
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500 transition-colors"
                    placeholder="Seu nome completo"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500 transition-colors"
                    placeholder="seu@email.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="empresa" className="block text-sm font-medium text-gray-300 mb-2">
                    Empresa *
                  </label>
                  <input
                    type="text"
                    id="empresa"
                    name="empresa"
                    value={formData.empresa}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500 transition-colors"
                    placeholder="Nome da sua empresa"
                  />
                </div>
                <div>
                  <label htmlFor="telefone" className="block text-sm font-medium text-gray-300 mb-2">
                    Telefone
                  </label>
                  <input
                    type="tel"
                    id="telefone"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500 transition-colors"
                    placeholder="(11) 99999-9999"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="cargo" className="block text-sm font-medium text-gray-300 mb-2">
                  Cargo
                </label>
                <input
                  type="text"
                  id="cargo"
                  name="cargo"
                  value={formData.cargo}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500 transition-colors"
                  placeholder="Seu cargo na empresa"
                />
              </div>

              <div>
                <label htmlFor="mensagem" className="block text-sm font-medium text-gray-300 mb-2">
                  Mensagem
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-blue-500 transition-colors"
                  placeholder="Conte-nos sobre seus desafios de prospecção..."
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">
                  {formData.mensagem.length}/500 caracteres
                </div>
              </div>

              <Button
                type="submit"
                variant="primary"
                size="lg"
                className="w-full"
                disabled={isSubmitting}
                icon={isSubmitting ? <i className="ri-loader-4-line animate-spin"></i> : <i className="ri-send-plane-line"></i>}
              >
                {isSubmitting ? 'Enviando...' : 'Acelerar Minhas Vendas'}
              </Button>

              {submitStatus === 'success' && (
                <div className="bg-green-600/20 border border-green-500/30 rounded-lg p-4 text-green-300 text-sm">
                  <i className="ri-check-line mr-2"></i>
                  Mensagem enviada com sucesso! Entraremos em contato em breve.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-600/20 border border-red-500/30 rounded-lg p-4 text-red-300 text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  Erro ao enviar mensagem. Tente novamente.
                </div>
              )}
            </form>
          </div>

          {/* Contact Info */}
          <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-6">Informações de Contato</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3 text-gray-300">
                <i className="ri-mail-line text-blue-400"></i>
                <a href="mailto:contato@takelead.com.br" className="hover:text-blue-400 transition-colors cursor-pointer">
                  contato@takelead.com.br
                </a>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <i className="ri-phone-line text-blue-400"></i>
                <a href="tel:+551150432111" className="hover:text-blue-400 transition-colors cursor-pointer">
                  +55 (11) 5043-2111
                </a>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <i className="ri-time-line text-blue-400"></i>
                <span>Segunda - Sexta: 8h às 18h</span>
              </div>
              <div className="flex items-center space-x-3 text-gray-300">
                <i className="ri-customer-service-2-line text-blue-400"></i>
                <span>Atendimento 24/7 via IA - Converse com a nossa Assistente de IA (Silvia), através do site ou por telefone, nos conte a sua história e necessidades, será um prazer pensarmos juntos e em soluções reais para sua Empresa!</span>
              </div>
            </div>
            
            {/* Process Flow Image */}
            <div className="mt-6 flex justify-center">
              <img 
                src="https://static.readdy.ai/image/54e10434a90951f6daafe5abdc38c83e/b7db7f17504675425e18446e1c49c898.jfif" 
                alt="Processo de Atendimento Take Lead" 
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
